import React from 'react'
import { pdfjs } from 'react-pdf';
import { useState } from 'react';
import { Document, Page } from 'react-pdf';
import './PdfView.css'
// pdfjs.GlobalWorkerOptions.workerSrc = new URL(
//     'pdfjs-dist/build/pdf.worker.min.mjs',
//     import.meta.url,
// ).toString();



pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const PdfView = ({ base64 }) => {
    const [numPages, setNumPages] = useState();
    const [pageNumber, setPageNumber] = useState(1);

    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
    }

    return (
        <div className='pdf-div'>
            <p>
                Page {pageNumber} of {numPages}
            </p>
            <Document file={base64} onLoadSuccess={onDocumentLoadSuccess}>
                {Array.apply(null, Array(numPages)).map((x, i) => i + 1).map(page => {
                    return (
                        <Page pageNumber={page} renderTextLayer={false} renderAnnotationLayer={false} />
                    )
                })}
            </Document>

        </div>
    );
}

export default PdfView